export const HOTELS_HEADER = "Hotels";

export const UPDATE_CALENDAR_TEXT = "Choose Dates";
